<template>
  <div
    v-if="!dataLoad"
    class="ft-toggle"
  >
    <span class="ft-label">Filteration Type</span>
    <div class="ft-group">
      <button
        type="button"
        :class="['ft-btn', { 'ft-btn--active': FilterTypeName === 'and' || !FilterTypeName }]"
        @click="setFilterType('and')"
      >
        AND
      </button>
      <button
        type="button"
        :class="['ft-btn', { 'ft-btn--active': FilterTypeName === 'or' }]"
        @click="setFilterType('or')"
      >
        OR
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      FilterTypeName: '' || this.$route.query.filter_type,
    }
  },
  computed: {
    optionsFilterType() {
      return [
        { value: 'and', text: 'AND' },
        { value: 'or', text: 'OR' },
      ]
    },
  },
  methods: {
    handleFilterType() {
      this.$router.push({
        query: { ...this.$route.query, filter_type: this.FilterTypeName },
      })
    },
    setFilterType(value) {
      this.FilterTypeName = value
      this.handleFilterType()
    },
  },
}
</script>

<style scoped lang="scss">
.ft-toggle {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.ft-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  margin-right: 0.45rem;
}

.ft-group {
  display: inline-flex;
  border-radius: 999px;
  overflow: hidden;
  background: #e5e7eb;
}

.ft-btn {
  border: none;
  background: transparent;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  color: #64748b;
  cursor: pointer;
  transition: background 0.1s, color 0.1s;
}

.ft-btn--active {
  background: #4f46e5;
  color: #f9fafb;
}
</style>
